export default "__VITE_ASSET__DRBHkaq1__"